import { render, staticRenderFns } from "./contaazul.vue?vue&type=template&id=88667b9e&scoped=true"
import script from "./contaazul.vue?vue&type=script&lang=js"
export * from "./contaazul.vue?vue&type=script&lang=js"
import style0 from "./contaazul.vue?vue&type=style&index=0&id=88667b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88667b9e",
  null
  
)

export default component.exports